import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyCX1HzYmAHzNwfvU7RAGPS423O4lNJJNw0",
  authDomain: "miyazaki-quiz-local-tv.firebaseapp.com",
  projectId: "miyazaki-quiz-local-tv",
  storageBucket: "miyazaki-quiz-local-tv.firebasestorage.app",
  messagingSenderId: "787943923809",
  appId: "1:787943923809:web:1862a09fc333a1b4cc0a20"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
